<template>
    <div>
        <span>{{ item.name }}</span>
    </div>
</template>

<script>
    import { Component, Prop, Vue } from 'vue-property-decorator';

    @Component({
        props: {
            item: {
                name: String
            }
        }
    })
    export default class SearchTemplate extends Vue {}
</script>